import { JobOfferEntryDto } from "../dtos/JobOfferEntryDto";
import { LocationDto } from "../dtos/LocationDto";

export class JobListWidgetRenderer {

    public constructor(private container: HTMLElement, private msg: string) { }

    public renderJobOffer(item: JobOfferEntryDto) {
        var entryHtml = document.createElement("div");
        entryHtml.classList.add("_jobEntry");

        var entryDetailsWrapper = document.createElement("a");
        entryDetailsWrapper.classList.add('_jobEntryDetails');
        entryDetailsWrapper.setAttribute("href", "/job/" + item.permaLink + "/");
        entryDetailsWrapper.setAttribute("target", "_blank");


        var entryTitle = document.createElement("div");
        entryTitle.classList.add('_jobEntryTitle')
        var entryTitle_h3 = document.createElement("h3");
        entryTitle_h3.innerHTML = item.title;
        entryTitle.appendChild(entryTitle_h3);

        var jobIcon = document.createElement("div");
        jobIcon.classList.add('_titleImage', 'jc-icon', 'jc-cat-icon', 'sizeResponsive', item.jobCategoryIcon);

        var jobCategory = document.createElement("div");
        jobCategory.classList.add("_jobAdress");
        jobCategory.innerHTML = LocationDto.getAddressString(item.location);



        entryHtml.appendChild(jobIcon);
        entryDetailsWrapper.appendChild(entryTitle);
        entryDetailsWrapper.appendChild(jobCategory);
        entryHtml.appendChild(entryDetailsWrapper);
        this.container.appendChild(entryHtml);
    }

    public renderError() {
        var entryHtml = document.createElement("div");
        var errorHtml = document.createElement("div");
        errorHtml.innerHTML = this.msg;
        errorHtml.classList.add('_entryErrorText')
        entryHtml.appendChild(errorHtml);
        this.container.appendChild(entryHtml);
    }


}